import React, { useState, useEffect } from 'react';
import Toast from './Toast';

let addToastCallback = null;

const ToastContainer = () => {
    const [toasts, setToasts] = useState([]);

    useEffect(() => {
        // Register global toast function
        addToastCallback = (message, type = 'info', duration = 5000) => {
            const id = Date.now();
            setToasts(prev => [...prev, { id, message, type, duration }]);
        };

        // Make it available globally
        window.showToast = addToastCallback;

        return () => {
            window.showToast = null;
            addToastCallback = null;
        };
    }, []);

    const removeToast = (id) => {
        setToasts(prev => prev.filter(toast => toast.id !== id));
    };

    return (
        <div className="fixed top-0 right-0 z-[9999] pointer-events-none">
            {toasts.map((toast, index) => (
                <div
                    key={toast.id}
                    style={{ marginTop: `${index * 80}px` }}
                >
                    <Toast
                        message={toast.message}
                        type={toast.type}
                        duration={toast.duration}
                        onClose={() => removeToast(toast.id)}
                    />
                </div>
            ))}
        </div>
    );
};

export default ToastContainer;

// Export function to show toast
export const showToast = (message, type = 'info', duration = 5000) => {
    if (addToastCallback) {
        addToastCallback(message, type, duration);
    } else if (window.showToast) {
        window.showToast(message, type, duration);
    } else {
        console.warn('Toast system not initialized:', message);
    }
};
